import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const RedirectPage = lazy(() => import('../pages/redirect/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const InventarioPerpetuo = lazy(() => import('../pages/inventario-perpetuo/page'));
const InventarioPeriodico = lazy(() => import('../pages/inventario-periodico/page'));
const CycleCountingPage = lazy(() => import('../pages/cycle-counting/page'));
const WallToWallPage = lazy(() => import('../pages/wall-to-wall/page'));
const SpotCheckingPage = lazy(() => import('../pages/spot-checking/page'));
const ABCAnalysisPage = lazy(() => import('../pages/abc-analysis/page'));
const PreparacaoInventarioPage = lazy(() => import('../pages/preparacao-inventario/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/redirect',
    element: <RedirectPage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/inventario-perpetuo',
    element: <InventarioPerpetuo />,
  },
  {
    path: '/inventario-periodico',
    element: <InventarioPeriodico />,
  },
  {
    path: '/cycle-counting',
    element: <CycleCountingPage />,
  },
  {
    path: '/wall-to-wall',
    element: <WallToWallPage />,
  },
  {
    path: '/spot-checking',
    element: <SpotCheckingPage />,
  },
  {
    path: '/abc-analysis',
    element: <ABCAnalysisPage />,
  },
  {
    path: '/preparacao-inventario',
    element: <PreparacaoInventarioPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
